import { SponsorTags } from "components/layout/sponsors/SponsorTags";
import { SponsoredContent } from "graphql/generated/types";
import { EventCardDetailsSection } from "./EventCardDetailsSection";

export type EventCardSponsorsProps = { 
    sponsoredContents: SponsoredContent[] | null | undefined 
}

export const EventCardSponsors: React.FC<EventCardSponsorsProps> = ({ sponsoredContents }) => {
    if (!sponsoredContents || sponsoredContents.length === 0) return null;

    return (
        <EventCardDetailsSection>
            <SponsorTags sponsoredContents={sponsoredContents}/>
        </EventCardDetailsSection>
    );
}; 
